import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, Tooltip } from '@sumtotal/react-foundation';
import PropTypes, { checkPropTypes } from 'prop-types';
import useCustomNavigation from '../../hooks/useCustomNavigation';
import { postMessage } from '../../../modules/core/services/coreIFrameHelper';
import {
  StyledCard,
  StyledCardActionArea,
  CardContentDiv,
  NotificationDot,
  IconContainer,
  IconDiv,
  ContentDiv,
  NameDiv,
  StyledSpan,
  DescriptionDiv,
  NotificationListItem,
  NotificationCardDivider,
  ColoredActivityName,
  StyledLink,
  SrOnlySpan
} from './notificationStyles';
import useUserContext from '../../hooks/useUserContext';
import getLogger from '../../../utils/logger';
import { updateInappNotificationsReadStatus } from '../services/notificationService';
import authService from '../../../authentication/AuthorizeService';
import decodeHtmlEntities from '../../../utils/htmlHelper';

const NotificationCard = (props) => {
  const {
    notificationData = defaultProps.notificationData,
    updateNotification = defaultProps.updateNotification,
    closeDrawer = defaultProps.closeDrawer
  } = props;
  checkPropTypes(NotificationCard.propTypes, props, 'prop', NotificationCard.name);
  const { user } = useUserContext();
  const navigate = useCustomNavigation();
  const { t } = useTranslation(['TRANSLATIONS_RCORE_TOPNAV']);
  const [tenantKey, setTenantKey] = useState('');
  const { Title, Description } = JSON.parse(notificationData.notificationMessage);
  let description = ``;
  let NotificationAct = '';
  if (notificationData.notificationKey === 'LearningActivityAssignmentNotif') {
    const { ActivityName } = JSON.parse(notificationData.macroData);
    NotificationAct = ActivityName;
  }
  let descriptionSplitArray = [];
  const { ActivityName, DueDate } = JSON.parse(notificationData.macroData);
  const formattedDate = DueDate ? new Date(DueDate).toLocaleDateString(user.culture) : undefined;
  if (notificationData.notificationKey === 'LearningActivityDuedateRemainderNotif') {
    description = Description;
    description = description.replace(DueDate, formattedDate);
    descriptionSplitArray = description.split('<br>');
  } else if (
    notificationData.notificationKey === 'LearningActivityAssignmentNotif' ||
    notificationData.notificationKey === 'LearningActivityCompletionNotif' ||
    notificationData.notificationKey === 'LearningActivityRegistrationNotif'
  ) {
    description = [decodeHtmlEntities(Description)];
    description = description[0].replace(DueDate, formattedDate).split(ActivityName);
  }
  const { isRead, time } = notificationData;

  function updateActivityName(activityName) {
    const modifiedActivityName =
      activityName.length > 100 ? `${activityName.substring(0, 100)}...` : `${activityName}.`;
    return activityName.length > 100 ? (
      <Tooltip title={activityName} arrow placement="bottom-start">
        <ColoredActivityName>{modifiedActivityName}</ColoredActivityName>
      </Tooltip>
    ) : (
      <span>
        <ColoredActivityName>{modifiedActivityName}</ColoredActivityName>
      </span>
    );
  }

  useEffect(() => {
    (async () => {
      const userProfile = await authService.getUserProfile();
      setTenantKey(userProfile.tenant);
    })();
  }, []);
  const updateInappNotificationsStatus = (notificationId, isReadStatus, event) => {
    if (event) event.stopPropagation();
    updateInappNotificationsReadStatus(tenantKey, user.personPK, notificationId, isReadStatus)
      .then((results) => {
        if (results) {
          updateNotification(notificationId);
        }
        return null;
      })
      .catch((err) => {
        getLogger().error(err.response);
      });
  };
  const handleCardActionAreaClick = (notifData, updateReadStatus, event) => {
    event.stopPropagation();
    if (updateReadStatus) updateInappNotificationsStatus(notifData.notificationId, true);
    closeDrawer();
    switch (notifData.notificationKey) {
      case 'LearningActivityAssignmentNotif':
      case 'LearningActivityRegistrationNotif':
      case 'LearningActivityDuedateRemainderNotif':
        // eslint-disable-next-line no-case-declarations
        const data = JSON.parse(notifData.macroData);
        // eslint-disable-next-line no-case-declarations
        let url = `/learning/core/activitydetails/ViewActivityDetails?ActivityId=${JSON.parse(
          // eslint-disable-next-line no-case-declarations
          data.ActivityId
        )}&UserMode=0`;
        url = `/c/pillarRedirect?relyingParty=LM&url=${encodeURIComponent(url)}`;
        navigate(url);
        break;
      case 'LearnerGamificationNotif':
        postMessage('OPEN_BADGES_AND_LEVELS');
        break;
      case 'LearningActivityCompletionNotif':
        // eslint-disable-next-line no-case-declarations
        let transcriptPage = `/learning/app/management/LMS_LearnerReports.aspx?UserMode=0&Mode=1`;
        transcriptPage = `/c/pillarRedirect?relyingParty=LM&url=${encodeURIComponent(
          transcriptPage
        )}`;
        navigate(transcriptPage);
        break;
      default:
        throw new Error(`Not handled notification'${notifData.notificationKey}'`);
    }
  };
  const dot = isRead ? (
    <div />
  ) : (
    <Icon iconType="MaterialIcon" iconName="FiberManualRecord" size={0.5} />
  );
  return (
    <NotificationListItem>
      <StyledCard>
        <StyledCardActionArea
          onClick={(event) => handleCardActionAreaClick(notificationData, !isRead, event)}
        >
          <CardContentDiv>
            <NotificationDot>{dot}</NotificationDot>
            <IconContainer>
              <IconDiv>
                <Icon iconType="IcomoonIcon" iconName="learningactivity" size={1.25} />
              </IconDiv>
            </IconContainer>
            <ContentDiv>
              <NameDiv>
                {Title}
                <StyledSpan>{time}</StyledSpan>
              </NameDiv>
              <DescriptionDiv>
                {notificationData.notificationKey === 'LearningActivityDuedateRemainderNotif' ? (
                  <>
                    {descriptionSplitArray[0]}
                    <br />
                    {descriptionSplitArray[1]}
                    <br />
                    {descriptionSplitArray[2] && descriptionSplitArray[2].replace(ActivityName, '')}
                    {ActivityName && updateActivityName(ActivityName)}
                  </>
                ) : (
                  <div>
                    {description[0] && description[0]}
                    {ActivityName && updateActivityName(ActivityName)}
                  </div>
                )}
              </DescriptionDiv>
            </ContentDiv>
          </CardContentDiv>
        </StyledCardActionArea>
        <StyledLink
          component="button"
          id={`button-${notificationData.notificationId}`}
          underline="hover"
          onClick={(event) =>
            updateInappNotificationsStatus(notificationData.notificationId, !isRead, event)
          }
        >
          {isRead
            ? t('RCORE_INAPP_NOTIFICATION_ACTION_MARK_AS_UNREAD')
            : t('INAPP_NOTIFICATION_MARK_AS_READ')}
          <SrOnlySpan>{NotificationAct}</SrOnlySpan>
        </StyledLink>
      </StyledCard>
      <NotificationCardDivider />
    </NotificationListItem>
  );
};
// PropType check
NotificationCard.propTypes = {
  /**
   * Notification Data
   */
  notificationData: PropTypes.shape({
    time: PropTypes.string,
    isRead: PropTypes.bool,
    data: PropTypes.string,
    macroData: PropTypes.string,
    notificationId: PropTypes.string,
    notificationMessage: PropTypes.string,
    notificationKey: PropTypes.string
  }),
  /**
   * Notification read status change callback
   */
  updateNotification: PropTypes.func,
  /**
   * Callback to close the drawer
   */
  closeDrawer: PropTypes.func
};
const defaultProps = {
  notificationData: undefined,
  updateNotification: undefined,
  closeDrawer: undefined
};
export default NotificationCard;
